import { ActionTypes } from "../type";

const initialState = {};

const resultEntryObservationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_RESULT_ENTRY_OBSERVATIONS:
      return {
        ...state,
        ...action.payload,
      };

    case ActionTypes.UPDATE_RESULT_ENTRY_OBSERVATION: {
      const { department, investigation, obsId, value } = action.payload;

      const currentInvestigation = state[department]?.[investigation];

      if (!currentInvestigation) {
        return state;
      }

      if (
        currentInvestigation.observations &&
        Array.isArray(currentInvestigation.observations)
      ) {
        return {
          ...state,
          [department]: {
            ...state[department],
            [investigation]: {
              ...currentInvestigation,
              observations: currentInvestigation.observations.map((obs) =>
                obs.observation_id === obsId
                  ? { ...obs, observation_value: value }
                  : obs,
              ),
            },
          },
        };
      }

      if (Array.isArray(currentInvestigation)) {
        return {
          ...state,
          [department]: {
            ...state[department],
            [investigation]: currentInvestigation.map((obs) =>
              obs.observation_id === obsId
                ? { ...obs, observation_value: value }
                : obs,
            ),
          },
        };
      }

      console.warn(
        "Unexpected data structure in reducer:",
        currentInvestigation,
      );
      return state;
    }

    case ActionTypes.RESET_RESULT_ENTRY_OBSERVATIONS:
      return initialState;

    default:
      return state;
  }
};

export default resultEntryObservationReducer;
